import React, { useEffect, useRef, useState } from "react";
import classes from "./SwipeGame.module.css"
import { mapValues } from "react-sdk/utils";
import SoundPlayer from "react-sdk/SoundPlayer";
import clsx from "clsx";
import { FaArrowLeft, FaArrowRight } from "react-icons/fa6";
import { observer } from "mobx-react-lite";
import SwipeRecap from "./SwipeRecap";
import Media from "../Media/Media";

const SwipeProposition = ({proposition, onFinished}) => {

  const [angle, setAngle] = useState(0);
  const [transforms, setTransforms] = useState([0, -200]);
  let [x, y] = transforms
  const [active, setActive] = useState(false);

  const answered = proposition.userAnswer !== null


  useEffect(() => {

    setTransforms([0, 0])
    setAngle(0)

  }, [proposition]);

  useEffect(() => {
    if(answered) {
      window.removeEventListener("mouseup", handleMouseUp)
      window.removeEventListener("mousemove", handleMouseMove)
      window.removeEventListener("touchmove", handleTouchMove)
      window.removeEventListener("touchend", handleMouseUp)
    }
  }, [answered]);

  let style = {
    transform: `rotateZ(${angle}deg)`,
    // opacity: answered ? 0 : 1
  }


  useEffect(() => {
    if(active) {
      window.addEventListener("mousemove", handleMouseMove)
      window.addEventListener("mouseup", handleMouseUp)

      window.addEventListener("touchmove", handleTouchMove)
      window.addEventListener("touchend", handleMouseUp)
    }
    return  () => {
      window.removeEventListener("mouseup", handleMouseUp)
      window.removeEventListener("mousemove", handleMouseMove)
      window.removeEventListener("touchmove", handleTouchMove)
      window.removeEventListener("touchend", handleMouseUp)
    }
  }, [active, angle]);

  function calulateAngle(x) {
    let angle = mapValues(x, 0, window.innerWidth, -90, 90, true)
    return angle
  }


  function handleMouseDown(e) {
    SoundPlayer.playSound("click")
    if(answered) return
    setActive(true)
  }
  function handleMouseMove(e) {
    if(!active) return
    if(answered) return
    setAngle(calulateAngle(e.clientX))
  }
  function handleTouchMove(e) {
    if(!active) return
    if(answered) return
    let x = e?.touches[0]?.clientX
    if(x) setAngle(calulateAngle(x))
  }

  function handleMouseUp(e) {
    if(!active) return
    if(Math.abs(angle) > 30) {
      setAngle(100 * Math.sign(angle))
      setTimeout(() => {
        handleAnswer()
      }, 500)
    }
    else {
      setAngle(0)
      SoundPlayer.playSound("click")
    }

    setActive(false)

  }

  function handleAnswer() {

    let value = angle < 0 ? false : true
    proposition.answer(value)

    onFinished()
    // setTimeout(() => {
    // }, 3000)
  }

  let answerOpacity = mapValues(Math.abs(angle), 0, 35, 0, 0.99, true)

  return(
    <div className={classes.card_ctnr} key={proposition.ID}>
      <div

      className={clsx(classes.card, active && classes.dragging)}
      style={style}
      onMouseEnter={e => SoundPlayer.playSound("rollover")}
      onMouseDown={handleMouseDown}
      onTouchStart={handleMouseDown}
      >
        <div className={classes.card_bg} />
        <div className={classes.card_text}>
          {proposition.Text }

          {proposition.media && <Media path={ proposition.media} />}
        </div>


        {!answered &&
        <div className={classes.answer} >
          {angle > -5 && angle < 5 &&
          <div className={classes.arrows}>
            <div className={clsx(classes.arrow)}>
              <FaArrowLeft className={classes.arrow_icon} />
              <div className={clsx(classes.arrow_text)}>
                {proposition.incorrectIcon && <img src={proposition.incorrectIcon} />}
                {proposition.incorrectText}
              </div>
            </div>
            <div className={clsx(classes.arrow)}>
              <FaArrowRight className={classes.arrow_icon} />
              <div className={clsx(classes.arrow_text)}>
                {proposition.correctText}
                {proposition.correctIcon && <img src={proposition.correctIcon} />}
              </div>
            </div>
          </div>}

          {angle <= -5 &&
          <div key={proposition.ID + "_0"} className={classes.future_answer} style={{opacity: answerOpacity}}>
            {proposition.incorrectText}
          </div>}

          {angle >= 5 &&
          <div key={proposition.ID + "_1"} className={classes.future_answer} style={{opacity: answerOpacity}}>
            {proposition.correctText}
          </div>}

        </div>}
      </div>
    </div>
  )
}




const SwipeGame = ({instance, onDone}) => {
  const [propositionIndex, setPropositionIndex] = useState(0);
  const [style, setStyle] = useState({});
  const ctnrRef = useRef(null)

  useEffect(() => {
    let bb = ctnrRef.current?.getBoundingClientRect()
    if(bb) {
      setStyle({top: bb.top, position: "absolute"})

    }


  }, []);

  function onPopositionDone() {
    if(propositionIndex < instance.Propositions.length - 1) {
      setPropositionIndex(i => i+1)
    }
    else {
      onDone()
    }
  }

  return (
    <div className={classes.SwipePropositionsCtnr} ref={ctnrRef}
    style={style}
    >
      <SwipeProposition
      proposition={instance.Propositions[propositionIndex]}
      onFinished={onPopositionDone} />

      <div className={classes.total}>{propositionIndex+1} / {instance.Propositions.length} </div>

    </div>
  )
}

export default observer(SwipeGame)